import LoaderPage from "src/components/Loader/LoaderPage";
import { useAppSelector } from "src/redux/store";
import Layout from "src/router/AuthenticatedRouter/Layout";
import CheckUsageRow from "./Components/CheckUsageRow";
import { ReactComponent as Comments } from "src/assets/svg/comments.svg";
import Button from "src/components/Button";
import { useState } from "react";
import SupportModal from "./Components/SupportModal";

const UsagePage = () => {
  const [support, setSupport] = useState(false);
  const constraints = useAppSelector((r) => r.client.client?.Company.UsageConstraints);

  if (!constraints) return <LoaderPage />;

  const {
    accounts_limit,
    active_jobs_limit,
    talent_search_enabled,
    resume_enabled,
    video_recording_enabled,
    _accounts,
    _completed_monthly_job_interviews,
    completed_monthly_job_interviews_limit,
    plan
  } = constraints;

  return (
    <Layout
      title={`Usage`}
      rightChildren={
        <Button
          onClick={() => setSupport(true)}
          className="!rounded-full !py-4 !px-6 !h-fit"
          shapeVariant={2}
        >
          <Comments className="mr-[10px] h-6 w-6" /> Contact Support
        </Button>
      }
    >
      <div className="px-9 py-6 flex gap-9 items-center bg-white rounded-2xl border-[1px] border-[#ccc]">
        <p className="py-3 text-xl">
          <span className="text-odfblue text-[32px] font-semibold">{_accounts}</span> out of{" "}
          {accounts_limit} users
        </p>
        <p className=" py-3 text-xl pl-9 border-l-[1px] border-l-[#ccc] ">
          <span className="text-odfblue text-[32px] font-semibold">
            {_completed_monthly_job_interviews}
          </span>{" "}
          out of {completed_monthly_job_interviews_limit} monthly interviews
        </p>
      </div>

      <p className="mt-12 mb-6 text-xl font-semibold">Plan Details</p>

      <div className="py-9 bg-white rounded-2xl border-[1px] border-odfblue">
        <div className="flex pb-9 gap-4 items-center px-9 border-b-[1px] border-b-[#ccc]">
          <p className="text-[28px] font-semibold">{plan}</p>
          <p className="flex  font-medium items-center pl-[6px] pr-[10px]  text-success border-success border-[1px] rounded-xl">
            <span className="text-3xl mr-1">• </span> Active
          </p>
        </div>
        <div className="pt-9 px-9 ">
          <div className="pb-9 flex gap-[100px] border-b-[1px] border-b-[#ccc]">
            <CheckUsageRow checked>
              {completed_monthly_job_interviews_limit} monthly interviews
            </CheckUsageRow>
            <CheckUsageRow checked>{accounts_limit} recruiter seat</CheckUsageRow>
            <CheckUsageRow checked>{active_jobs_limit} active jobs</CheckUsageRow>
          </div>
          <div className="pt-9 flex gap-[100px] ">
            <CheckUsageRow checked={talent_search_enabled}>Talent Search</CheckUsageRow>
            <CheckUsageRow checked={video_recording_enabled}>Video Recordings</CheckUsageRow>
            <CheckUsageRow checked={resume_enabled}>Resume Review</CheckUsageRow>
          </div>
        </div>
      </div>

      <p className="text-xl mt-9">
        Contact{" "}
        <span onClick={() => setSupport(true)} className="text-odfblue underline cursor-pointer">
          Support
        </span>{" "}
        to upgrade plan
      </p>

      <SupportModal open={support} close={() => setSupport(false)} />
    </Layout>
  );
};

export default UsagePage;
